/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:6eadab21-6fbc-4f03-9981-d9c00b635c60",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_l59ZMbhkL",
    "aws_user_pools_web_client_id": "5p0vunn0kbfplu657gvhu7cm53",
    "oauth": {},
    "aws_user_files_s3_bucket": "sofbucket-38c0f7664cbdview-prod",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "sof-prod",
            "region": "us-east-2"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "dreamportalsofview",
            "endpoint": "https://95f5yinxq8.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        }
    ],
    "aws_content_delivery_bucket": "dreamportal-sof-view-20200510200208-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "https://d280cky24if6s1.cloudfront.net"
};


export default awsmobile;
